import { ArrowBack } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

type BackArrowTextProps = {
  text?: string;

  url: string;
};

export const BackArrowText = ({ text, url }: BackArrowTextProps) => {
  return (
    <Button
      component={Link}
      to={url}
      sx={{
        display: "flex",
        alignItems: "center",
        color: "inherit",
        textDecoration: "none",
        mr: "auto",
      }}
    >
      <ArrowBack />
      {text ? <Typography sx={{ marginLeft: "5px" }}>{text}</Typography> : null}
    </Button>
  );
};
